/** @jsx jsx */
import { jsx, css } from '@emotion/core' // eslint-disable-line
import React, { Component, useState } from 'react' // eslint-disable-line
import { Link } from 'react-router-dom'
import { Layout, Menu, Icon } from 'antd'

import menuGroup from './menu'

import FastMenu from '../../../components/business/FastMenu'

const { Sider } = Layout
const { SubMenu } = Menu

const sideBarStyles = {
  sidebar: css`
    background: #fff;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.1);

    .ant-menu-inline {
      border: none;
    }
  `, // border-right: 1px solid #e8e8e8;
  'side-status': css`
    width: 100%;
    height: 64px;
    padding: 16px;
  `,
  'status-content': css`
    height: 30px;
    line-height: 30px;
    border: none;
    background: #3863ff;
    color: #fff;
    border-radius: 5px;
    outline: none;
    user-select: none;
  `,
  'side-menu': css`
    .ant-menu-submenu-title {
      text-align: left;
    }
    .ant-menu-item {
      text-align: left;
    }
  `,
}

// const logoStyles = {
//   'side-logo': css`
//     width: 100%;
//     height: 64px;
//   `,
//   'logo-link': css`
//     display: inline-block;
//     padding: 10px 16px;
//     width: 100%;
//     height: 100%;
//     background: #343434;
//   `,
//   'logo-image': css`
//     width: 100%;
//     height: 100%;
//   `,
// }

function buildSubMenu(group: any, groupData: any) {
  return (
    <SubMenu
      key={group}
      title={
        <span>
          <Icon type={groupData['icon']} />
          <span>{groupData['title']}</span>
        </span>
      }
    >
      {groupData['group'].map((menuData: any) => {
        return (
          <Menu.Item key={`${menuData['path']}`}>
            <Link to={menuData['path']}>· {menuData['title']}</Link>
          </Menu.Item>
        )
      })}
    </SubMenu>
  )
}

interface SidePanelProps {
  location: any
  defaultPage: string
}

export default (props: SidePanelProps) => {
  let defaultPath = props.location.pathname
  if (defaultPath === '/') {
    defaultPath = props.defaultPage
  }
  const openList = menuGroup
    .filter((groupData) => {
      if (defaultPath.startsWith(`/${groupData.key}`)) {
        return true
      }
      return false
    })
    .map((groupData) => groupData.key)

  const [openKeys, onOpenChange] = useState(openList)
  const activeKeys = [defaultPath]

  return (
    <Sider
      css={sideBarStyles.sidebar}
      breakpoint="lg"
      collapsedWidth="0"
      onBreakpoint={(broken: any) => {
        console.log(broken)
      }}
      onCollapse={(collapsed: any, type: any) => {
        console.log(collapsed, type)
      }}
    >
      {/* <div className="logo" css={logoStyles['side-logo']}>
      <a css={logoStyles['logo-link']} href="/">
        <img
          src={LogoAICloud}
          css={logoStyles['logo-image']}
          alt="AI-Cloud"
        />
      </a>
    </div> */}

      <div className="side-status" css={sideBarStyles['side-status']}>
        <div className="status-content" css={sideBarStyles['status-content']}>
          <FastMenu>Working</FastMenu>
        </div>
      </div>

      <Menu
        mode="inline"
        defaultSelectedKeys={activeKeys}
        openKeys={openKeys}
        onOpenChange={onOpenChange}
        css={sideBarStyles['side-menu']}
      >
        {/* <MachineMenuGroup location={location}/> */}
        {menuGroup.map((groupData) => {
          return buildSubMenu(groupData['key'], groupData)
        })}
      </Menu>
    </Sider>
  )
}
